import { wafChallengeManager } from '@/services/waf/WAFChallengeManager';
import { cloudflareTurnstileClearanceProvider } from './CloudflareTurnstileClearanceProvider';
import { registerCloudflareWAFChallengeDetector } from './detection';

/**
 * Registers Cloudflare WAF detection and sets the clearance provider on the recovery manager. Both operations
 * are idempotent, so this may run more than once. The caller must also mount
 * `<CloudflareTurnstileClearanceHost/>` (main.tsx for the app, apps/src/waf-clearance-host.tsx for the tool
 * page) or a solve never renders.
 */
export const initCloudflareWAFProvider = (): void => {
  registerCloudflareWAFChallengeDetector();
  wafChallengeManager.setChallengeProvider(cloudflareTurnstileClearanceProvider);
};
